import { useLayoutEffect, useRef } from "react";

import { ANIMATION_DURATION_MS, ANIMATION_TIMING_FUNCTION } from "app/modules/project-from-comparison/config";

export const useAnimateListChanges = (items: string[]) => {
    const prevItemsRef = useRef<string[]>([]);
    const positionsRef = useRef<Map<string, DOMRect>>(new Map());

    useLayoutEffect(() => {
        const prevItems = prevItemsRef.current;
        const positions = positionsRef.current;

        if (prevItems.length === 0) {
            items.forEach((item) => {
                const element = document.querySelector<HTMLElement>(`[data-domain="${item}"]`);
                if (element) {
                    positions.set(item, element.getBoundingClientRect());
                }
            });
            prevItemsRef.current = items;
            return;
        }

        const hasOrderChanged = items.some((item, index) => prevItems[index] !== item);

        if (hasOrderChanged) {
            items.forEach((item) => {
                const element = document.querySelector<HTMLElement>(`[data-domain="${item}"]`);
                if (element) {
                    const prevPosition = positions.get(item);
                    const currentPosition = element.getBoundingClientRect();

                    if (prevPosition) {
                        const deltaY = prevPosition.top - currentPosition.top;

                        if (deltaY !== 0) {
                            element.style.transform = `translateY(${deltaY}px)`;
                            element.style.transition = "none";

                            requestAnimationFrame(() => {
                                element.style.transform = "";
                                element.style.transition = `transform ${ANIMATION_DURATION_MS}ms ${ANIMATION_TIMING_FUNCTION}`;
                            });
                        }
                    }

                    positions.set(item, currentPosition);
                }
            });
        }

        prevItemsRef.current = items;
    }, [items]);
};
